import React, { ComponentProps, useMemo } from "react";
import DeltaMathTable from "../../../shared/DeltaMathTable";
import JsonDisplay from "../../../shared/JSONDisplay";

type OldDiff = {
  last_edit: {
    updated: number;
    original: number;
  };
  original: Record<string, unknown>;
  [key: string]: any;
};

const DiffHistoryOld: React.FC<{ diffs: OldDiff[] }> = ({ diffs }) => {
  const columns = useMemo(() => {
    const c: ComponentProps<typeof DeltaMathTable>["columns"] = [
      {
        Header: "Updated At",
        accessor: "last_edit.updated",
        Cell: ({ value }: { value: number }) => (
          <span>{new Date(value * 1000).toLocaleString()}</span>
        ),
        align: "left",
      },
      {
        Header: "Original",
        accessor: "last_edit.original",
        Cell: ({ value }: { value: number }) => (
          <span>{new Date(value * 1000).toLocaleString()}</span>
        ),
        align: "left",
      },
      {
        Header: "Assignment Diff",
        accessor: "diff",
        Cell: ({ row }: { row: any }) => (
          <div key={`diff-${row.id}`}>
            <JsonDisplay data={row.original} />
          </div>
        ),
        align: "left",
      },
    ];
    return c;
  }, []);

  return (
    <div>
      <div className="flex items-center justify-between py-2">
        <h2 className="text-lg font-semibold text-gray-900">
          Assignment Diffs (Old)
        </h2>
      </div>

      <DeltaMathTable data={diffs} columns={columns} />
    </div>
  );
};

export default DiffHistoryOld;
